export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000"
export const MAX_CAMPAIGN_MESSAGE_LENGTH = 1024
